import { deleteRenewVisaDocumentCreationGroupListApi } from "@/api/services/main/renew-visa";
import { ConfirmSaveModal } from "@/components/commons/ConfirmSaveModal";
import { Button } from "@/components/elements/Button";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useDialog } from "@/hooks/useDialog";
import { showError } from "@/utils/error";
import { toNumber } from "@/utils/number";
import { toast } from "@/utils/toast";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { FC } from "react";

type TDeleteMoreRenewVisaDocumentBtnProps = {
  selectedRenewVisaDocumentIds: string[];
  clearSelectedRenewVisaDocument: () => void;
  renewVisaDocumentStepGroupId: number;
  renewVisaDocumentGroupId: string | undefined;
};

export const DeleteMoreRenewVisaDocumentBtn: FC<TDeleteMoreRenewVisaDocumentBtnProps> = ({
  selectedRenewVisaDocumentIds,
  renewVisaDocumentGroupId,
  clearSelectedRenewVisaDocument,
  renewVisaDocumentStepGroupId,
}) => {
  const queryClient = useQueryClient();

  const confirmDeleteMoreRenewVisaDocument = useDialog();

  const handleDeleteMoreRenewVisaDocument = async () => {
    if (!renewVisaDocumentGroupId || !renewVisaDocumentStepGroupId) return;
    try {
      const agree = await confirmDeleteMoreRenewVisaDocument.show();
      if (!agree) return;

      const rs = await deleteRenewVisaDocumentCreationGroupListApi(renewVisaDocumentGroupId, renewVisaDocumentStepGroupId, {
        renewVisaDocumentIds: selectedRenewVisaDocumentIds.map((item) => toNumber(item)),
      });
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_DOCUMENT_CREATION_GROUP] });
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_APPLICATION_INFORMATION_GROUP] });
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_APPLICATION_RESULT_INFORMATION_GROUP] });
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_RESIDENCE_CARD_INFORMATION_GROUP] });
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_LIST] });
      clearSelectedRenewVisaDocument();
      toast.success(rs.message ?? API_SUCCESS_MESSAGE);
    } catch (error) {
      showError(error);
    }
  };

  return (
    <>
      <Button disabled={selectedRenewVisaDocumentIds.length === 0} variant="danger" onClick={handleDeleteMoreRenewVisaDocument}>
        チェックした外国人を削除
      </Button>

      <ConfirmSaveModal
        title="削除の確認"
        open={confirmDeleteMoreRenewVisaDocument.open}
        onOk={confirmDeleteMoreRenewVisaDocument.confirm}
        onClose={confirmDeleteMoreRenewVisaDocument.cancel}
      >
        <Typography variant="subtitle1" component="p">
          外国人を削除してもよろしいですか？
        </Typography>
      </ConfirmSaveModal>
    </>
  );
};
